import { Menu, Button } from "@mantine/core"
import { ChevronDown } from "lucide-react"
import "./SignUpSelectField.css"
import { useState } from "react"

export interface SignUpSelectFieldOption {
	text: JSX.Element
	key: string
}

export interface SignUpSelectFieldProps {
	options: string[] | SignUpSelectFieldOption[]
	placeholder: string | SignUpSelectFieldOption
	label: string | JSX.Element
	required?: boolean
	updateField?: (option) => void
	onSelect?: (option) => void
	fieldName: string
	selectedItemStyle?: React.CSSProperties
	size?: "small" | "medium" | "full-width"
	labelPosition?: "top" | "inline"
}

export function SignUpSelectField({
	updateField,
	options,
	label,
	fieldName,
	required = false,
	placeholder,
	selectedItemStyle,
	size = "full-width",
	labelPosition = "top",
	onSelect,
}: Readonly<SignUpSelectFieldProps>) {
	const [opened, setOpened] = useState(false)
	const [selectedOption, setSelectedOption] = useState(placeholder)

	const handleToggle = () => {
		setOpened(!opened)
	}

	const handleClose = () => {
		setOpened(false)
	}

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === " " || e.key === "Enter") {
			e.preventDefault()
			handleToggle()
		}
	}

	const handleSelect = (option: string) => {
		setSelectedOption(option)
		updateField && updateField({ [fieldName]: option })
		onSelect && onSelect(option)
		handleClose()
	}

	return (
		<div className={`sign-up-select sign-up-select-label-position-${labelPosition}`}>
			<label className="bs-label">
				{label} {required && <span style={{ color: "var(--ara-red" }}>{" *"}</span>}
			</label>
			<div className={`sign-up-select-${size}`}>
				<Menu opened={opened} onClose={handleClose} position="bottom-start" withinPortal={false}>
					<Menu.Target>
						<Button
							className="sign-up-select-toggle"
							onClick={handleToggle}
							onKeyDown={handleKeyDown}
							variant="default"
							rightSection={<ChevronDown size={16} />}>
							<span style={selectedItemStyle}>
								{typeof selectedOption === "string" ? selectedOption : selectedOption.text}
							</span>
						</Button>
					</Menu.Target>
					<Menu.Dropdown className="sign-up-select-menu">
						{options.map((option) => {
							if (option.text) {
								return (
									<Menu.Item onClick={() => handleSelect(option.key)} key={option.key}>
										{option.text}
									</Menu.Item>
								)
							} else {
								return (
									<Menu.Item onClick={() => handleSelect(option)} key={option}>
										{option}
									</Menu.Item>
								)
							}
						})}
					</Menu.Dropdown>
				</Menu>
			</div>
		</div>
	)
}
